export default "<template>\n    <section>\n        <o-skeleton circle width=\"64px\" height=\"64px\" />\n    </section>\n</template>\n"